import { apiClient } from './client';

export interface AdminReplyPlaybookPayload {
  topic: string;
  title: string;
  trigger_phrases: string[];
  recommended_answer: string;
  allowed_channels?: string[];
  risk_level?: 'low' | 'medium' | 'high';
  needs_human_review?: boolean;
  notes?: string;
}

export interface AdminReplyPlaybook {
  id: number;
  tenant_id: string;
  slug: string;
  title: string;
  payload: AdminReplyPlaybookPayload;
}

export interface AdminReplyPlaybookShare {
  token: string;
  scope: 'playbook' | 'tenant_page';
  share_url: string;
  tenant_slug: string;
  playbook_id?: number;
  playbook_slug?: string;
  playbook_title?: string;
  expires_at?: string;
  is_active: boolean;
  created_at: string;
  revoked_at?: string;
}

export interface CreateAdminReplyPlaybookShareRequest {
  tenant_slug: string;
  expires_at?: string;
}

export async function fetchAdminReplyPlaybooks(tenantSlug?: string): Promise<AdminReplyPlaybook[]> {
  const { data } = await apiClient.get<{ items: AdminReplyPlaybook[] }>('/admin-reply-playbooks', {
    params: tenantSlug ? { tenant_slug: tenantSlug } : undefined,
  });
  return data.items;
}

export async function fetchAdminReplyPlaybookShares(
  playbookId: number,
  tenantSlug: string
): Promise<AdminReplyPlaybookShare[]> {
  const { data } = await apiClient.get<{ items: AdminReplyPlaybookShare[] }>(
    `/admin-reply-playbooks/${playbookId}/shares`,
    { params: { tenant_slug: tenantSlug } }
  );
  return data.items;
}

export async function fetchAdminReplyPlaybookPageShares(tenantSlug: string): Promise<AdminReplyPlaybookShare[]> {
  const { data } = await apiClient.get<{ items: AdminReplyPlaybookShare[] }>('/admin-reply-playbooks/shares', {
    params: { tenant_slug: tenantSlug },
  });
  return data.items;
}

export async function createAdminReplyPlaybookShare(
  playbookId: number,
  payload: CreateAdminReplyPlaybookShareRequest
): Promise<AdminReplyPlaybookShare> {
  const { data } = await apiClient.post<AdminReplyPlaybookShare>(
    `/admin-reply-playbooks/${playbookId}/shares`,
    payload
  );
  return data;
}

export async function createAdminReplyPlaybookPageShare(
  payload: CreateAdminReplyPlaybookShareRequest
): Promise<AdminReplyPlaybookShare> {
  const { data } = await apiClient.post<AdminReplyPlaybookShare>('/admin-reply-playbooks/shares', payload);
  return data;
}

export async function revokeAdminReplyPlaybookShare(playbookId: number, token: string): Promise<void> {
  await apiClient.delete(`/admin-reply-playbooks/${playbookId}/shares/${token}`);
}

export async function revokeAdminReplyPlaybookPageShare(token: string): Promise<void> {
  await apiClient.delete(`/admin-reply-playbooks/shares/${token}`);
}
